<template>
    <card class="card--grid">
        <div class="row">
            <div class="col-6">
                <card-header>
                    <card-overline>Kunde
                        <form-button icon="pen-edit" dense="dense" color="transparent"
                                     @click="askForQuoteAddressPop = !askForQuoteAddressPop"/>
                        <div class="pop-menu" v-if="askForQuoteAddressPop" @click="askForQuoteAddressPop = false;">
                            <nav>
                                <ul>
                                    <li><a
                                        @click="selectedAskForQuoteAddress = askForQuote?.ask_for_quote_invoice_address; askForQuoteAddressModal = true;">Rechnungsadresse
                                        bearbeiten</a></li>
                                    <li><a
                                        @click="selectedAskForQuoteAddress = askForQuote?.ask_for_quote_delivery_address; askForQuoteAddressModal = true;">Lieferadresse
                                        bearbeiten</a></li>
                                </ul>
                            </nav>
                        </div>
                    </card-overline>
                    <ask-for-quote-address :ask-for-quote-address="selectedAskForQuoteAddress"
                                           v-if="askForQuoteAddressModal"
                                           @closeDialog="selectedAskForQuoteAddress = null; askForQuoteAddressModal = false;"
                                           :client-countries="clientCountries"/>
                </card-header>
                <card-content>
                    <div class="row">
                        <div class="col col-6">
                            <p class="body-2">
                                <strong>Rechnungsadresse</strong><br>
                                {{ askForQuote?.ask_for_quote_invoice_address?.company }}<br>
                                {{ askForQuote?.ask_for_quote_invoice_address?.name }}<br>
                                {{ askForQuote?.ask_for_quote_invoice_address?.street }}
                                {{ askForQuote?.ask_for_quote_invoice_address?.street_no }}<br>
                                {{ askForQuote?.ask_for_quote_invoice_address?.zip }}
                                {{ askForQuote?.ask_for_quote_invoice_address?.city }}<br>
                                {{ askForQuote?.ask_for_quote_invoice_address?.client_country.country_name }}
                            </p>
                            <p class="body-2">
                                <span v-if="askForQuote?.ask_for_quote_invoice_address?.phone">Tel.: {{ askForQuote?.ask_for_quote_invoice_address?.phone }}<br></span>
                                <span v-if="askForQuote?.ask_for_quote_invoice_address?.mobile">Mobil.: {{ askForQuote?.ask_for_quote_invoice_address?.mobile }}<br></span>
                                <span v-if="askForQuote?.ask_for_quote_invoice_address?.fax">Fax.: {{ askForQuote?.ask_for_quote_invoice_address?.fax }}</span>
                            </p>
                        </div>
                        <div class="col col-6">
                            <p class="body-2">
                                <strong>Lieferadresse</strong><br>
                                {{ askForQuote?.ask_for_quote_delivery_address?.company }}<br>
                                {{ askForQuote?.ask_for_quote_delivery_address?.name }}<br>
                                {{ askForQuote?.ask_for_quote_delivery_address?.street }}
                                {{ askForQuote?.ask_for_quote_delivery_address?.street_no }}<br>
                                {{ askForQuote?.ask_for_quote_delivery_address?.zip }}
                                {{ askForQuote?.ask_for_quote_delivery_address?.city }}<br>
                                {{ askForQuote?.ask_for_quote_delivery_address?.client_country.country_name }}


                            </p>
                            <p class="body-2">
                                <span v-if="askForQuote?.ask_for_quote_delivery_address?.phone">Tel.: {{ askForQuote?.ask_for_quote_delivery_address?.phone }}<br></span>
                                <span v-if="askForQuote?.ask_for_quote_delivery_address?.mobile">Mobil.: {{ askForQuote?.ask_for_quote_delivery_address?.mobile }}<br></span>
                                <span v-if="askForQuote?.ask_for_quote_delivery_address?.fax">Fax.: {{ askForQuote?.ask_for_quote_delivery_address?.fax }}</span>
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col col-6">
                            <p class="body-2">
                                <strong>Zahlungsart</strong><br>
                                {{ paymentType }}
                            </p>
                        </div>
                        <div class="col col-6">
                            <p class="body-2">
                                <strong>Bewertung bestätigt?</strong><br>
                                {{ rateLater }}
                            </p>
                        </div>
                    </div>
                </card-content>
            </div>
            <div class="col-6">
                <card-header>
                    <card-overline>Dokumente</card-overline>
                </card-header>
                <card-content>
                    <table class="table table--card table--stripped">
                        <thead>
                        <tr>
                            <th>Dokumentenname</th>
                            <th>Datum</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-if="askForQuoteInvoiceFile">
                            <td>K-Rechnung</td>
                            <td>{{$dateTime(this.askForQuote.ask_for_quote_invoice.created_at)}}</td>
                            <td>
                                <a :href="askForQuoteInvoiceFile"
                                   class="btn btn--dense btn--icon-inline">
                                    <svg-vue icon="documents-file-search" class="icon"/>
                                </a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </card-content>
            </div>
        </div>
    </card>
</template>

<script>
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import Card from '@partfactory/Shared/Card/Card';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import CardContent from '@partfactory/Shared/Card/CardContent';
import FormButton from '@partfactory/Shared/Form/FormButton';
import AskForQuoteAddress from '@partfactory/Pages/Admin/AskForQuote/Modals/AskForQuoteAddress';

export default {
    name: 'ClientInformation',
    components: {AskForQuoteAddress, FormButton, CardContent, CardOverline, Card, CardHeader},
    props: {
        askForQuote: Object,
        clientCountries: Object,
    },
    data() {
        return {
            askForQuoteAddressPop: false,
            askForQuoteAddressModal: false,
            selectedAskForQuoteAddress: null,
        };
    },
    computed: {
        paymentType() {
            return this.askForQuote?.client_order ? this.$readablePaymentType(this.askForQuote?.client_order?.payment_type) : '-';
        },
        rateLater() {
            return this.askForQuote?.client_order ? this.askForQuote.rate_later ? 'Ja' : 'Nein' : '-';
        },
        askForQuoteInvoiceFile() {
            return this.askForQuote.ask_for_quote_invoice ? this.$$route('ask-for-quote-documents.download', {'askForQuoteDocuments': this.askForQuote.ask_for_quote_invoice?.id}) : null;
        },
    },
};
</script>
